import { select } from 'redux-saga/effects';
import { find } from 'underscore';
import { smoothScrollToElement } from './scroll';

// NOTE: despite their names, none of these methods enforce JSON requests or responses :(
export function getJSON(url, data = {},  options = {}) {
    const args = {...options, type: 'GET', data: data, xhrFields: { withCredentials: true }};
    return Promise.resolve($.ajax(url, args));
}

export function postJSON(url, data = {}, options = {}) {
    const args = {...options, type: 'POST', data: data, xhrFields: { withCredentials: true }};
    return Promise.resolve($.ajax(url, args));
}

export function putJSON(url, data = {}, options = {}) {
    const args = {...options, type: 'PUT', data: data, xhrFields: { withCredentials: true }};
    return Promise.resolve($.ajax(url, args));
}

export function deleteJSON(url, data = {}, options = {}) {
    const args = {...options, type: 'DELETE', data: data, xhrFields: { withCredentials: true }};
    return Promise.resolve($.ajax(url, args));
}

export function truncate(str, max) {
    if (!str || str.length <= max) {
        return str + ' ';
    }
    var charLimit = str.substring(0, max);
    var wordLimit = Math.min(charLimit.length, charLimit.lastIndexOf(' '));
    return charLimit.substring(0, wordLimit).trim() + '… ';
}

export const attributesToObject = (attrs) =>
    Array.prototype.reduce.call(attrs, (obj, attr) => {
        obj[attr.name] = attr.value;
        return obj;
    }, {});

export const bind = (context, names) => {
    names.forEach((name) => {
        const original = context[name];
        context[name] = function bound() {
            return original.apply(context, arguments);
        };
    });
};

export function* getFavoriteDeck(user) {
    if (!user.favorite_deck_id) {
        return null;
    }
    const decks = yield select(state => state.decks);
    if (!decks || !decks.length) {
        return null;
    }
    return find(decks, deck =>
        deck.deck == user.favorite_deck_id
    );
}

export const params = (obj) => Object.keys(obj).map(k => `${k}=${encodeURIComponent(obj[k])}`).join('&');

export const hasTouchEvents = document.children
    ? document.children[0].classList.contains('touchevents')
    : document.childNodes[1].classList.contains('touchevents');

//use hashes that start with '!' to trigger smoothScrollToElement on page load
if (window.location.hash && window.location.hash.match(/\!/)) {
    const hash = window.location.hash.replace(/\!/, '');
    const target = document.querySelector(hash);

    if (target) {
        smoothScrollToElement(target);
    }
}

export function ordinal(num) {
    const j = num % 10;
    const k = num % 100;

    if (j == 1 && k != 11) {
        return num + 'st';
    }

    if (j == 2 && k != 12) {
        return num + 'nd';
    }

    if (j == 3 && k != 13) {
        return num + 'rd';
    }

    return num + 'th';
}

export function shuffle(array) {
    let m = array.length;
    let t, i;

    while (m) {
        i = Math.floor(Math.random() * m--); // Pick a remaining element…

        // And swap it with the current element.
        t = array[m];
        array[m] = array[i];
        array[i] = t;
    }

    return array;
}



// WEBPACK FOOTER //
// ./app/util.js